export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)

  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  const currentSegments = current.split('/').filter(Boolean)
  const urlSegments = url.split('/').filter(Boolean)

  if (urlSegments.length > 0 && currentSegments.length >= urlSegments.length) {
    let isMatch = true
    for (let i = 0; i < urlSegments.length; i++) {
      if (currentSegments[i] !== urlSegments[i]) {
        isMatch = false
        break
      }
    }

    if (
      isMatch &&
      (currentSegments.length === urlSegments.length ||
        currentSegments[urlSegments.length] === undefined)
    ) {
      return true
    }
  }

  return false
}
